import React, { useEffect, useState } from "react";
import { Badge, Spinner, Modal, Table } from "react-bootstrap";
import { FiArrowRight, FiPackage, FiTruck, FiUser, FiInfo, FiActivity } from "react-icons/fi";
import logo from "../images/TP-_logo-orizz-claim-color.png";
import "bootstrap/dist/css/bootstrap.min.css";

const WidgetCrossDocking = () => {
  const [datiRaw, setDatiRaw] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    fetch("ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const lista = data?.CROSS_DOCKING?.flat() || [];
        setDatiRaw(lista);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore Cross Docking:", err);
        setLoading(false);
      });
  }, []);

  const testate = datiRaw.filter((item) => item.Is_Totale === "1");

  const handleOpenDettaglio = (ordine) => {
    const articoli = datiRaw.filter(
      (d) =>
        d.Is_Totale === "0" &&
        d.Doc_Cliente === ordine.Doc_Cliente &&
        d.Doc_Fornitore === ordine.Doc_Fornitore,
    );
    setSelectedOrder({ ...ordine, articoli });
    setShowModal(true);
  };

  return (
    <div className="shadow-lg card" style={{
        borderRadius: "16px", border: "1px solid #333", height: "100%",
        display: "flex", flexDirection: "column", background: "#121212", overflow: "hidden" ,
      height: "350px",
    }}>
      {/* Header Widget - Resta Dark come da tua impostazione originale */}
      <div className="p-3 border-bottom d-flex justify-content-between align-items-center" style={{ background: "#1a1a1a", borderColor: "#333" }}>
        <span style={{ fontWeight: "800", fontSize: "0.75rem", color: "#b81f25", letterSpacing: "1.5px" }}>
            <FiActivity className="me-2"/> CROSS-DOCKING LIVE
        </span>
        <Badge bg="danger" className="rounded-pill" style={{ fontSize: '0.6rem', backgroundColor: '#b81f25' }}>
          {testate.length} ATTIVI
        </Badge>
      </div>

      <style>{`
        .scroll-area-cd { overflow-y: auto; flex-grow: 1; padding: 15px; }
        .scroll-area-cd::-webkit-scrollbar { width: 4px; }
        .scroll-area-cd::-webkit-scrollbar-thumb { background: #444; border-radius: 10px; }
        
        .cd-card { 
            background: #1e1e1e; border: 1px solid #333; border-radius: 12px; 
            margin-bottom: 15px; padding: 18px; cursor: pointer; 
            transition: all 0.3s ease; position: relative;
        }
        .cd-card:hover { 
            border-color: #b81f25; background: #252525;
            box-shadow: 0 8px 25px rgba(184, 31, 37, 0.15) !important; 
        }
        .cd-card::before {
            content: ''; position: absolute; left: 0; top: 15%; height: 70%; width: 3px;
            background: #b81f25; border-radius: 0 4px 4px 0;
        }

        .flow-line { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
        .node { flex: 1; min-width: 0; }
        .node-label { font-size: 0.6rem; color: #666; font-weight: 800; text-transform: uppercase; margin-bottom: 4px; }
        .node-doc { font-size: 0.85rem; font-weight: 700; color: #b81f25; font-family: 'Monaco', monospace; }
        .node-name { font-size: 0.75rem; color: #ccc; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        
        .arrow-box { display: flex; flex-direction: column; align-items: center; color: #b81f25; min-width: 70px; }
        .arrow-icon { animation: slideRight 2s infinite; font-size: 1.1rem; margin-top: 5px; }
        
        @keyframes slideRight {
            0% { transform: translateX(-4px); opacity: 0.4; }
            50% { transform: translateX(4px); opacity: 1; }
            100% { transform: translateX(-4px); opacity: 0.4; }
        }

        /* LIGHT MODAL OVERRIDES */
        .modal-light-custom .modal-content { 
            background: #ffffff; 
            border: none; 
            border-radius: 16px; 
            color: #212529; 
        }
        .modal-light-custom .modal-header { 
            border-bottom: 1px solid #dee2e6; 
            background-color: #f8f9fa;
            border-top-left-radius: 16px;
            border-top-right-radius: 16px;
        }
        .info-strip-light { 
            background: #f1f3f5; 
            border: 1px solid #dee2e6; 
            border-radius: 12px;
        }
        .table-light-custom th {
            color: #6c757d;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
      `}</style>

      <div className="scroll-area-cd">
        {loading ? (
          <div className="text-center py-5"><Spinner animation="border" variant="danger" /></div>
        ) : (
          testate.map((item, idx) => (
            <div key={idx} className="cd-card shadow-lg" onClick={() => handleOpenDettaglio(item)}>
              <div className="flow-line">
                <div className="node text-start">
                  <div className="node-label"><FiTruck className="me-1"/> Provenienza</div>
                  <div className="node-doc">{item.Doc_Fornitore}</div>
                  <div className="node-name">{item.Fornitore}</div>
                </div>

                <div className="arrow-box">
                  <Badge bg="transparent" className="border border-danger text-danger" style={{ fontSize: '0.55rem' }}>
                    {item.Conteggio} RIGHE
                  </Badge>
                  <FiArrowRight className="arrow-icon" />
                </div>

                <div className="node text-end">
                  <div className="node-label"><FiUser className="me-1"/> Destinatario</div>
                  <div className="node-doc text-light">{item.Doc_Cliente}</div>
                  <div className="node-name">{item.Cliente}</div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* MODALE DETTAGLIO - TEMA CHIARO */}
      <Modal 
        show={showModal} 
        onHide={() => setShowModal(false)} 
        centered 
        size="lg" 
        className="modal-light-custom p-5"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold d-flex align-items-center" style={{ fontSize: '1rem', color: '#b81f25' }}>
            <FiPackage className="me-2"/> ANALISI FLUSSO LOGISTICO
          </Modal.Title>
        </Modal.Header>
        
        <Modal.Body className="bg-white">
          {/* Info Strip Chiaro */}
          <div className="info-strip-light p-3 mb-4 d-flex justify-content-between align-items-center">
            <div style={{ flex: 1 }}>
              <small className="text-muted d-block" style={{ fontSize: '0.65rem', fontWeight: '700' }}>FORNITORE</small>
              <span className="fw-bold text-dark" style={{ fontSize: '0.9rem' }}>{selectedOrder?.Fornitore}</span>
              <div className="text-muted" style={{ fontSize: '0.75rem' }}>Doc: {selectedOrder?.Doc_Fornitore}</div>
            </div>
            <div className="px-3" style={{ color: '#b81f25' }}><FiArrowRight size={24}/></div>
            <div style={{ flex: 1 }} className="text-end">
              <small className="text-muted d-block" style={{ fontSize: '0.65rem', fontWeight: '700' }}>CLIENTE</small>
              <span className="fw-bold text-dark" style={{ fontSize: '0.9rem' }}>{selectedOrder?.Cliente}</span>
              <div className="text-muted" style={{ fontSize: '0.75rem' }}>Doc: {selectedOrder?.Doc_Cliente}</div>
            </div>
          </div>

          <Table responsive hover className="mb-0 table-light-custom">
            <thead>
              <tr style={{ borderBottom: '2px solid #f1f1f1' }}>
                <th className="pb-3" style={{ fontSize: '0.7rem' }}>Descrizione Articolo</th>
                <th className="text-center pb-3" style={{ fontSize: '0.7rem' }}>Quantità</th>
                <th className="text-end pb-3" style={{ fontSize: '0.7rem' }}>Stato</th>
              </tr>
            </thead>
            <tbody>
              {selectedOrder?.articoli.map((art, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #f8f9fa' }}>
                  <td className="py-3">
                    <div className="fw-bold text-dark" style={{ fontSize: '0.85rem' }}>{art.articolo}</div>
                    <div className="text-muted" style={{ fontSize: '0.75rem' }}>Cod: <span className="text-dark fw-medium">{art.precodice || "N/A"}</span></div>
                  </td>
                  <td className="text-center py-3">
                    <Badge pill style={{ backgroundColor: '#b81f25', padding: '6px 14px', fontSize: '0.8rem' }}>
                        {art.Conteggio}
                    </Badge>
                  </td>
                  <td className="text-end py-3">
                    <Badge bg="success-subtle" className="text-success border border-success-subtle" style={{ fontSize: '0.65rem', fontWeight: '700' }}>
                        ● PRONTO
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>

        <Modal.Footer className="bg-light border-top-0 justify-content-center">
          <img 
            src={logo} 
            alt="Logo" 
            style={{ width: "100px", filter: "grayscale(1)", opacity: 0.6 }} 
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default WidgetCrossDocking;